module.exports = __webpack_public_path__ + "img/pinterest.1ee9d1c7.svg";